import {Modifier, EditorState} from 'draft-js';
import {ToolbarWrapper} from "./ToolbarWrapper";
import {useLanguage} from "../context/LanguageContext";

const ToolbarAddSymbol = ({editorState, setEditorState, symbols}) => {
    const {t} = useLanguage();
    const addSymbol = (symbol) => {
        const contentState = editorState.getCurrentContent();
        const selectionState = editorState.getSelection();
        const newContentState = Modifier.insertText(contentState, selectionState, symbol);
        const newEditorState = EditorState.push(editorState, newContentState, 'insert-characters');
        setEditorState(newEditorState);
    }

    return (
        <div style={{display: "flex", gap: "5px"}}>
            {symbols.map(symbol => (
                <ToolbarWrapper key={symbol}>
                    <button
                        type="button"
                        title={symbol}
                        aria-label={t('textSection.addSymbol', {symbol})}
                        onClick={() => addSymbol(symbol)}
                        style={{
                            background: "none",
                            border: "none",
                            padding: 0,
                            margin: 0,
                            cursor: "pointer",
                            fontSize: "inherit",
                            lineHeight: "inherit"
                        }}
                    >
                        {symbol}
                    </button>
                </ToolbarWrapper>
            ))}
        </div>
    );
}

export default ToolbarAddSymbol;
